import { Injectable } from '@angular/core';
import {
  CanActivate,
  CanActivateChild,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
} from '@angular/router';

import { Observable } from 'rxjs';
import { AuthService } from '../_services/auth.service';
import { ToastrService } from 'ngx-toastr';
import { map } from 'rxjs/operators';
import { of } from 'rxjs';
import { environment } from '@app/../environments/environment';

@Injectable()
export class CanActivateRouteGuard implements CanActivate {
  constructor(
    private router: Router,
    private authService: AuthService,
    private toastr: ToastrService
  ) {}
  //   canActivate(route: ActivatedRouteSnapshot): Observable<boolean> | boolean {
  //     const permissions = route.data['permissions'] as Array<string>;
  //     if (permissions) {
  //       this.authService.getMyPermissions().subscribe((lstPermission) => {
  //         // const isHasPermission = lstPermission.includes(permissions);
  //         const isHasPermission = lstPermission.some((item) => permissions.includes(item));
  //         if (!isHasPermission) {
  //           //   this.router.navigateByUrl('/error/403');
  //           this.toastr.error('Bạn không có quyền truy cập vào chức năng này');
  //         }
  //         return;
  //       });
  //     }
  //     return true;
  //   }
  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    const permissions = route.data['permissions'] as Array<string>;
    if (!permissions) return of(true);

    const token = localStorage.getItem(environment.authTokenKey);
    if (!token) {
      this.router.navigateByUrl('/auth/login');
      return of(false);
    }

    return this.authService.getMyPermissions().pipe(
      map((lstPermission) => {
        if (!lstPermission) {
          this.router.navigateByUrl('/auth/login');
          return false;
        }
        const isHasPermission = lstPermission.some((item) => permissions.includes(item));
        if (!isHasPermission) {
          this.toastr.error('Bạn không có quyền truy cập vào chức năng này');
        }
        return isHasPermission;
      })
    );
  }
}
